import styled from 'styled-components';
import { Row } from '../grid/grid-component';

const Card = styled.div`
  visibility: ${(props) => (props.$visible ? 'hidden' : '')};
  padding: ${(props) => props.$padding || '0 !important'};
  border-radius: ${(props) => props.$borderRadius};
  width: ${(props) => props.$width || '100%'};
  height: ${(props) => props.$height || '100%'};
  min-height: ${(props) => props.$minHeight || 'unset'};
  background-color: ${(props) => props.$backgroundColor};
  border: ${(props) =>
    props.className === 'editMode' ? `2px solid grey` : 'none'};
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  margin: ${(props) => props.$margin || '0 0 30px 0'};
  border: ${(props) => props.$border ?? `1px solid ${props.theme.COLOR_GREY5}`};
  position: ${(props) => (props.$fixToBottom ? 'absolute' : 'relative')};
  bottom: ${(props) => (props.$fixToBottom ? '0' : 'unset')};
  left: ${(props) => (props.$fixToBottom ? '0' : 'unset')};
  right: ${(props) => (props.$fixToBottom ? '0' : 'unset')};
`;

const CardHeader = styled.div`
  border-bottom: 1px solid #333f48;
  display: flex;
  align-items: center;
  margin: ${(props) => props.$marginHeader};
  line-height: 25px;
  padding: 15px 15px;
  width: 100%;

  span {
    flex-shrink: 0;
    flex-grow: 1;
    font-size: 16px;
  }
`;
const CardBody = styled.div`
  line-height: 35px;
  padding: ${(props) => props.$padding || '15px'};
`;

const EditModeStyle = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px;
  font-size: 13px;
  position: absolute;
  top: -40px;
  right: 0;
  span {
    color: white;
    padding: 2px;
    border-radius: 5px;
  }
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: #eaedf3 !important;
  margin-bottom: 0px !important;
  padding: 24px !important;
  margin-right: auto !important;
  margin-left: auto !important;
  justify-content: end !important;
`;

const Bumper = styled.div`
  margin-left: 16px;
`;

const StyledCard = {
  Card,
  CardBody,
  CardHeader,
  EditModeStyle,
  RowStyle,
  Bumper,
};

export default StyledCard;
